// src/Redux/selectors/doctorProfileSelectors.js

/* =========================================================
   Base selector
   ⚠️ IMPORTANT:
   - Si ton reducer s'appelle "doctorProfile" => OK
   - Sinon, change ici (ex: state.doctorProfileSlice)
========================================================= */
export const selectDoctorProfileState = (state) => state?.doctorProfile ?? {};

/* =========================================================
   DoctorInfo
========================================================= */
export const selectDoctorInfo = (state) =>
  selectDoctorProfileState(state)?.doctorInfo?.data ?? null;

export const selectDoctorInfoLoading = (state) =>
  selectDoctorProfileState(state)?.doctorInfo?.loading ?? false;

export const selectDoctorInfoError = (state) =>
  selectDoctorProfileState(state)?.doctorInfo?.error ?? null;

/* =========================================================
   Mutations (upsert/update)
========================================================= */
export const selectDoctorProfileMutationLoading = (state) =>
  selectDoctorProfileState(state)?.mutation?.loading ?? false;

export const selectDoctorProfileMutationError = (state) =>
  selectDoctorProfileState(state)?.mutation?.error ?? null;
